import Vue from "vue";
import Router from "vue-router";
// import store from "./store";
// import axios from "axios";
Vue.use(Router);
let router = new Router({
    mode: "history",
    routes: [{
            path: "/",
            props: true,
            component: () =>
                import ("./views/home"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/WTIDonationForm",
            name: "WTIDonationForm",
            props: true,
            component: () =>
                import ("./views/home2"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/donationNewDesign",
            name: "donationNewDesign",
            props: true,
            component: () =>
                import ("./donations/donationNewDesign"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/DonationForm",
            name: "DonationForm",
            props: true,
            component: () =>
                import ("./donations/conservationHeroes"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/SupportCBRC",
            name: "SupportCBRC",
            props: true,
            component: () =>
                import ("./donations/SupportCBRC"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/cbrcStory",
            name: "cbrcStory",
            props: true,
            component: () =>
                import ("./donations/cbrcStory"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/DonationFormNew",
            name: "DonationFormNew",
            props: true,
            component: () =>
                import ("./views/DonationFormNew"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/orphaned-calf-rehabilitation",
            name: "orphanedCalfCampaign",
            props: true,
            component: () =>
                import ("./views/orphanedCalfCampaign"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/support-wildlife",
            name: "support-wildlife",
            props: true,
            component: () =>
                import ("./views/supportWildlife"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/global-wildlife-fair",
            name: "global-wildlife-fair",
            props: true,
            component: () =>
                import ("./views/GWF/gwfFinal.vue"),
            meta: {
                requiresAuth: false,
            },
        },
        
        {
            path: "/StoriesofImpact",
            name: "StoriesofImpact",
            props: true,
            component: () =>
                import ("./views/StoriesofImpact"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/refundAndCancellation",
            name: "refundAndCancellation",
            props: true,
            component: () =>
                import ("./components/Policy/refundAndCancellation"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/privacyPolicy",
            name: "privacyPolicy",
            props: true,
            component: () =>
                import ("./components/Policy/privacyPolicy"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/termsAndCondition",
            name: "termsAndCondition",
            props: true,
            component: () =>
                import ("./components/Policy/termsAndCondition"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/wccd",
            name: "wccd",
            props: true,
            component: () =>
                import ("./components/WCCD/wccd"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/ExGratia",
            name: "ExGratia",
            props: true,
            component: () =>
                import ("./views/ExGratia"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/RapidActionProgram",
            name: "RapidActionProgram",
            props: true,
            component: () =>
                import ("./views/RapidActionProgram"),
            meta: {
                requiresAuth: false,
            },
        },

        //payment routes
        {
            path: '/payment',
            props: true,
            name: 'payment',
            component: () =>
                import ('./Payment/payment'),
        },
        {
            path: '/support-wildlife-payment',
            props: true,
            name: 'payment',
            component: () =>
                import ('./Payment/supportwildPay.vue'),
        },
        {
            path: '/success',
            props: true,
            name: 'success',
            component: () =>
                import ('./Payment/success'),
        },
        {
            path: '/failure',
            props: true,
            name: 'failure',
            component: () =>
                import ('./Payment/failure'),
        },
        {
            path: '/error',
            props: true,
            name: 'failure',
            component: () =>
                import ('./Payment/ErrorPage'),
        },




        // end of payment routes

        {
            path: "/ServerError",
            name: "ServerError",
            props: true,
            component: () =>
                import ("./components/Common/500"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "*",
            name: "404PageNotFound",
            props: true,
            component: () =>
                import ("./components/Common/404"),
            meta: {
                requiresAuth: false,
            },
        },
    ],
    scrollBehavior() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0;
    },
});
// router.beforeEach((to, from, next) => {
//   if (to.fullPath !== "/Login") {
//     localStorage.setItem("routeKey", to.fullPath);
//   }
//   if (
//     store.state.isLoggedIn == true ||
//     to.matched.some((route) => route.meta.requiresAuth == true)
//   ) {
//     axios({
//       method: "POST",
//       url: "/authenticate/user",
//       headers: {
//         token: localStorage.getItem("token"),
//       },
//     })
//       .then((response) => {
//         if (!response.data.status) {
//           store.commit("sessionOut", true);
//           return;
//         }
//       })
//       .catch((err) => {
//         var msg = err;
//         console.log(msg);
//       });
//   }

//   if (
//     to.path == "/Seller" &&
//     store.state.isLoggedIn == true &&
//     store.state.userType == "customer"
//   ) {
//     next({ name: "Login" });
//     return;
//   }
//   if (
//     localStorage.getItem("profStat") == "active" &&
//     store.state.userType === "seller"
//   ) {
//     if (
//       to.path == "/" ||
//       (to.path == "/Login" &&
//         store.state.isLoggedIn == true &&
//         store.state.userType === "seller")
//     ) {
//       next({ name: "Seller" });
//       return;
//     }
//   }
//   if (
//     localStorage.getItem("profStat") == "incomplete" &&
//     store.state.userType === "seller"
//   ) {
//     if (
//       to.path == "/" ||
//       to.path == "/Seller" ||
//       (to.path == "/Login" &&
//         store.state.isLoggedIn == true &&
//         store.state.userType === "seller")
//     ) {
//       next({ name: "completeRegistration" });
//       return;
//     }
//   }

//   if (
//     localStorage.getItem("profStat") == "pending" &&
//     store.state.userType === "seller"
//   ) {
//     if (
//       to.path == "/" ||
//       to.path == "/Seller" ||
//       (to.path == "/Login" &&
//         store.state.isLoggedIn == true &&
//         store.state.userType === "seller")
//     ) {
//       next({ name: "completeRegistration" });
//       return;
//     }
//   }

//   if (
//     localStorage.getItem("profStat") == "reject" &&
//     store.state.userType === "seller"
//   ) {
//     if (
//       to.path == "/" ||
//       to.path == "/Seller" ||
//       (to.path == "/Login" &&
//         store.state.isLoggedIn == true &&
//         store.state.userType === "seller")
//     ) {
//       next({ name: "sellerStatus" });
//       return;
//     }
//   }


//   next();
// });

export default router;